import { ReportReviewerStatus } from "@api/graphql/types-and-hooks";
import { useIsPeerReviewEnabled } from "@components/QaReview/hooks/useIsPeerReviewEnabled";
import { DraftExportMenu } from "@components/ReportReview/DraftExportMenu";
import { RequestReviewButton } from "@components/ReportReview/RequestReviewButton";
import { ReviewChip } from "@components/ReportReview/ReviewChip";
import { ReviewersPopover } from "@components/ReportReview/ReviewersPopover";
import { FinishReviewButton } from "@components/ReportReview/actions/FinishReviewButton";
import { useCanReviewReport } from "@components/ReportReview/hooks/useCanReviewReport";
import { useMyAuth0Id } from "@components/ReportReview/hooks/useMyAuth0Id";
import { useReportReviewers } from "@components/ReportReview/hooks/useReportReviewers";

export const ReportReviewControls: React.FC = () => {
  const isPeerReviewEnabled = useIsPeerReviewEnabled();
  const myId = useMyAuth0Id();
  const { reviewers, isLoaded } = useReportReviewers();
  const myReview = useCanReviewReport();

  if (!isPeerReviewEnabled || !myId || !isLoaded) return null;

  return (
    <div className="flex shrink-0 items-center gap-2">
      <ReviewChip />
      {!!reviewers.length && <ReviewersPopover />}
      <DraftExportMenu />
      <RequestReviewButton />
      {myReview?.status === ReportReviewerStatus.Requested && <FinishReviewButton />}
    </div>
  );
};
